import styled from "styled-components";
import { Button, Table } from "discover.medical.react-component-library";

export const StyledCell = styled(Table.Cell)`
  background-color: transparent !important;
  padding: 0.5rem 0 !important;
`;

export const StyledRow = styled(Table.Row)`
  &:first-child {
    border-top: 1px ${({ theme }) => theme.colors.gray400} solid;
  }
  &:last-child {
    border-bottom: 0;
  }
`;

export const StyledBox = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.base};
  padding: 1.25rem;
  margin-top: 0.5rem;
  text-align: center;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.anchor} !important;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: ${({ theme }) => theme.space.sm};

  &:hover,
  &:focus {
    text-decoration: none;
    background-color: ${({ theme }) => theme.colors.gray400};
  }
`;
